export var NetsuiteObjectType = /*#__PURE__*/ function(NetsuiteObjectType) {
    NetsuiteObjectType["Account"] = "account";
    NetsuiteObjectType["Project"] = "project";
    NetsuiteObjectType["Budget"] = "budget";
    NetsuiteObjectType["Phase"] = "phase";
    NetsuiteObjectType["Task"] = "task";
    NetsuiteObjectType["TimeEntry"] = "timeEntry";
    NetsuiteObjectType["Invoice"] = "invoice";
    NetsuiteObjectType["InvoiceLineItem"] = "invoiceLineItem";
    NetsuiteObjectType["RevRecLedger"] = "revRecLedger";
    return NetsuiteObjectType;
}({});
export var NetsuitePageSource = /*#__PURE__*/ function(NetsuitePageSource) {
    NetsuitePageSource["AUTOMATION"] = "AUTOMATION";
    NetsuitePageSource["RESOURCE_MAPPINGS"] = "RESOURCE_MAPPINGS";
    return NetsuitePageSource;
}({});
// InvoiceLineItem is intentionally not a standalone menu item — line items
// are configured inside the Invoice automation, not as their own automation.
export const NETSUITE_OBJECT_MENU_ITEMS = [
    {
        id: "account",
        label: 'Account'
    },
    {
        id: "project",
        label: 'Project'
    },
    {
        id: "budget",
        label: 'Budget'
    },
    {
        id: "phase",
        label: 'Phase'
    },
    {
        id: "task",
        label: 'Task'
    },
    {
        id: "timeEntry",
        label: 'Time entry'
    },
    {
        id: "invoice",
        label: 'Invoice'
    },
    {
        id: "revRecLedger",
        label: 'Revenue recognition ledger'
    }
];
// These objects sync on a recurring schedule instead of reacting to record
// changes, so they are grouped under their own sidebar heading and are the
// only ones offering a force-sync action.
export const NETSUITE_SCHEDULE_BASED_OBJECTS = new Set([
    "timeEntry",
    "revRecLedger"
]);
export const DEFAULT_NETSUITE_OBJECT = "account";
// Maps frontend NetsuiteObjectType values → backend RocketlaneResourceType enum names.
// Only entries that differ need to be listed; everything else falls through as-is.
const NATIVE_RESOURCE_TYPE_MAP = {
    ["account"]: 'company',
    ["budget"]: 'projectFinancialsBudget'
};
export const toNativeResourceType = (obj)=>{
    var _NATIVE_RESOURCE_TYPE_MAP_obj;
    return (_NATIVE_RESOURCE_TYPE_MAP_obj = NATIVE_RESOURCE_TYPE_MAP[obj]) !== null && _NATIVE_RESOURCE_TYPE_MAP_obj !== void 0 ? _NATIVE_RESOURCE_TYPE_MAP_obj : obj;
};
// NetSuite external resource types available to map
export const NETSUITE_EXTERNAL_RESOURCE_TYPES = [
    {
        value: 'customer',
        label: 'Customer'
    },
    {
        value: 'project',
        label: 'Project'
    },
    {
        value: 'budget',
        label: 'Budget'
    },
    {
        value: 'projectTask',
        label: 'Project Task'
    },
    {
        value: 'timeBill',
        label: 'Time Bill'
    },
    {
        value: 'invoice',
        label: 'Invoice'
    },
    {
        value: 'revenueRecognitionSchedule',
        label: 'Revenue Recognition Schedule'
    },
    {
        value: 'subsidiary',
        label: 'Subsidiary'
    },
    {
        value: 'employee',
        label: 'Employee'
    },
    {
        value: 'vendor',
        label: 'Vendor'
    },
    {
        value: 'salesOrder',
        label: 'Sales Order'
    },
    {
        value: 'opportunity',
        label: 'Opportunity'
    }
];
